import React from "react";

export const InputFieldVolunteer = ({ formData, handleChange, isFormDisabled, labelColor }) => {
  return (
    <div className="p-4 border border-red-300 rounded bg-red-50">
      <h3 className="text-red-600 font-bold">Missing Component: InputFieldVolunteer</h3>
      <p className="text-red-500">
        The InputFieldVolunteer component was not found in the codebase. This is a placeholder.
      </p>
      {/* 
        Ideally, we would render the form fields here based on formData.
        Since the original code is missing, we can't reconstruct it perfectly without more info.
      */}
      <div className="mt-4">
        <label className={`block mb-2 ${labelColor}`}>Full Name</label>
        <input
          type="text"
          name="namaLengkap"
          value={formData.namaLengkap}
          onChange={handleChange}
          disabled={isFormDisabled}
          className="w-full p-2 border rounded"
        />
      </div>
      {/* Add more fields as needed for testing */}
    </div>
  );
};
